(ns manage.content-configuration-page.context-source.products
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            [manage.content-configuration-page.context-source.shared :as cs]
            [manage.content-configuration-page.view.input :as view.input]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]
            [uix.core :refer [$]]))

(def schema-id "urn:lemonpi:schema:context:products:v1")

;; database

(rf/reg-sub :products-context-source/product-selector-options
  :<- [:resource.schema/parameter-schema schema-id]
  (fn [parameter-schema _]
    (:options parameter-schema)))

(defmethod cs/parameter schema-id
  [context-source]
  (:products-context-source/product-selector-id context-source))

(defmethod cs/original-parameter schema-id
  [context-source]
  ;; if the user cleared the product selector field, don't restore the original
  ;; parameter when exporting to CFN
  (when (cs/parameter context-source)
    (:context-source/original-parameter context-source)))

(defmethod cs/context->constructor schema-id
  [{product-selector-id :param}]
  (when product-selector-id
    {:products-context-source/product-selector-id product-selector-id}))

;; UI

(defn choose-product-selector [pcs]
  (let [ds-input-props (view.input/props-entity pcs :products-context-source/product-selector-id)
        product-selector-id @(:subscription ds-input-props)
        url-context @(rf/subscribe [:url-context])]
    [:> Stack {:spacing 1}
     [view.input/dropdown-save-on-change
      (-> ds-input-props
          (assoc :validation/disabled? true
                 :validation/stages #{:publish-blocking})
          (assoc :dropdown/options-sub [:products-context-source/product-selector-options])
          (assoc-in [:control-props :disabled?] @(rf/subscribe [:resource.content-function-version/active-version? "published"]))
          (assoc-in [:form-field-props :label] "Product selector"))]
     [:> Button
      {:color "primary"
       :startIcon ($ Icon "launch")
       :disabled (not product-selector-id)
       :href (r.easy/href :advertiser/product-selector
                          url-context
                          {:product-selector-id product-selector-id})
       :target "_blank"
       :sx {:alignSelf "flex-start"}}
      "Open product selector"]]))

(defmethod cs/entity-view-cfg schema-id
  [pcs]
  (merge
   (cs/entity-view-cfg-base pcs)
   {:entity/read-only? false
    :list-item/details [choose-product-selector pcs]}))

(defmethod cs/entity-query-params schema-id
  [_]
  {:menu :dynamic-data})
